import { render, staticRenderFns } from "./InputWithIconSlot.vue?vue&type=template&id=5ba4a1b7&lang=pug&"
import script from "./InputWithIconSlot.vue?vue&type=script&lang=js&"
export * from "./InputWithIconSlot.vue?vue&type=script&lang=js&"
import style0 from "./InputWithIconSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports